import { render, staticRenderFns } from "./hecoos_lighting.vue?vue&type=template&id=4b8516cf&scoped=true"
import script from "./hecoos_lighting.vue?vue&type=script&lang=js"
export * from "./hecoos_lighting.vue?vue&type=script&lang=js"
import style0 from "./hecoos_lighting.vue?vue&type=style&index=0&id=4b8516cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8516cf",
  null
  
)

export default component.exports